import { ReportToPercent } from './ReportToPercent';

export default ReportToPercent;
